<mat-paginator
  [length]="length"
  [pageSize]="pageSize"
  [pageSizeOptions]="pageSizeOptions"
  [disabled]="disabled"
  (page)="page.emit($event)"
></mat-paginator>
